import { Link } from "wouter";
import { useLanguage } from "../contexts/LanguageContext";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <div className="relative flex min-h-[60vh] flex-col items-center justify-center gap-6 overflow-hidden p-8">
      <div className="bg-grid bg-grid-fade absolute inset-0 opacity-40" />
      <div className="relative space-y-3 text-center">
        <p className="font-display text-[120px] font-light leading-none tracking-tighter text-primary/80">
          404
        </p>
        <p className="font-display text-2xl font-medium tracking-tight">
          {t({ "zh-TW": "找不到頁面", "en-US": "Page not found", "zh-CN": "找不到页面" })}
        </p>
        <p className="max-w-sm text-[13px] text-muted-foreground">
          {t({
            "zh-TW": "你嘗試造訪的路徑不存在，或你的角色沒有權限存取。",
            "en-US": "This route doesn't exist, or your role isn't allowed here.",
            "zh-CN": "你尝试造访的路径不存在，或你的角色没有权限存取。",
          })}
        </p>
      </div>
      <Link href="/">
        <Button variant="outline">
          <ArrowLeft className="h-3.5 w-3.5" />
          {t({ "zh-TW": "回首頁", "en-US": "Go home", "zh-CN": "回首页" })}
        </Button>
      </Link>
    </div>
  );
}
